import { httpClient } from '@connectors/HttpClient'

import type { Coupon } from '../types'

export type CouponBody = Pick<Coupon, 'code' | 'expiry' | 'productId'>

export const CouponService = {
    get: async (id: string): Promise<Coupon> => {
        const response = await httpClient.axios.get(`/admin/coupons/${id}`)
        return response.data
    },
    list: async (): Promise<Coupon[]> => {
        const response = await httpClient.axios.get('/admin/coupons')
        return response.data
    },
    update: async (id: string, params: CouponBody): Promise<any> => {
        const response = await httpClient.axios.put(`/admin/coupons/${id}`, params)
        return response.data
    },
    create: async (params: CouponBody): Promise<any> => {
        const response = await httpClient.axios.post('/admin/coupons', params)
        return response.data
    },
    remove: async (id: string): Promise<any> => {
        const response = await httpClient.axios.delete(`/admin/coupons/${id}`)
        return response.data
    }
}
